import {
  deleteSheetData,
  getSheetDataForDetail,
  lockOrUnlockSheetData
} from "@/api/sheet/sheetData"
import { clickSheetBtn, fillForm } from "@/api/sheet/sheetBtn"
import { getSheetDefForDetail } from "@/api/sheet/sheet"
import { decorateSheet } from "@/utils/sheet"
import { deepClone } from "@/utils/common"

export default {
  methods: {
    deleteSheetData(dataId, appId) {
      return this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        return deleteSheetData({ dataId: dataId, appId: appId }).then(res => {
          this.$message.success("刪除成功")
          return res
        })
      })
    },
    editReference(data, sheetData, sheetDef) {
      if (!sheetData.data[this.activeCustomBtn.fillCids[0].cid])
        sheetData.data[this.activeCustomBtn.fillCids[0].cid] = [data.id]
      else sheetData.data[this.activeCustomBtn.fillCids[0].cid].push(data.id)
      return fillForm({
        appId: sheetDef.appId,
        btnId: this.activeCustomBtn.id,
        dataId: this.dataId,
        data: sheetData.data
      })
    },
    lockOrUnlockData(sheetData) {
      let msg = sheetData.locked
        ? "确认解锁该记录（解锁后将可以编辑）?"
        : "确认锁定该记录（锁定后将不可编辑）?"
      return this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        return lockOrUnlockSheetData(sheetData.sheetId, sheetData.id, sheetData.locked).then(() => {
          this.$message.success("操作成功!")
        })
      })
    },
    handleCopyData(dataId, appId, sheetDef) {
      getSheetDataForDetail({ dataId: dataId, appId }).then(sheetData => {
        let controls = sheetDef.controls || []
        let controlsMap = this._.keyBy(controls, "_cid")
        let data = {}
        for (const key in sheetData.data) {
          let control = controlsMap[key]
          if (!control) continue
          if (control._type === "ref" && (!control.oneFlag || control.related)) continue
          if (control._type === "sn") continue
          data[key] = sheetData.data[key]
        }
        data = this._.cloneDeep(data)
        this.copyData = data
        this.$refs.editDialog.open()
      })
    },
    customBtnRequest(appId, dataId, btnId, sheetId) {
      let param = { appId, dataId, btnId, sheetId }
      return clickSheetBtn(param).then(() => {
        this.$message.success("操作成功！")
      })
    },
    async fill(btn, dataId, appId) {
      let data = await getSheetDataForDetail({ dataId: dataId, appId })
      let sheetData = {}
      let sheetDef = {}
      if (btn.refCid) {
        sheetData = data.data[btn.refCid]
        if (!sheetData || sheetData.length == 0) {
          this.$message.error("当前无关联数据")
          return
        }
        sheetData = sheetData[0]
        let def = await getSheetDefForDetail(sheetData.sheetId, sheetData.id)
        sheetDef = decorateSheet(def)
        this.btnSheetDef = deepClone(sheetDef)
        if (!sheetDef.controls.some(x => x._cid == btn.fillCids[0].cid))
          this.$message.error("自定义按钮配置有误")
        if (btn.fillType == "CREATE_REF") {
          let btnSheet = sheetDef.controls.find(x => x._cid == btn.fillCids[0].cid)
          if (btnSheet.oneFlag && sheetData.data[btn.fillCids[0].cid]?.length == 1) {
            this.$message.error("当前已存在关联数据")
            return
          }
          this.btnSheetData = deepClone(sheetData)
          this.btnSheetId = btnSheet.refSheetId
          this.btnCcid = btnSheet._ccid
          this.btnDataId = ""
          this.$refs.btnEditDialog.open()
        } else {
          this.btnSheetId = sheetData.sheetId
          this.btnDataId = sheetData.id
          this.$refs.fillDialog.open()
        }
      } else {
        sheetData = data
        let def = await getSheetDefForDetail(sheetData.sheetId, sheetData.id)
        sheetDef = decorateSheet(def)
        this.btnSheetDef = deepClone(sheetDef)
        let btnSheet = sheetDef.controls.find(x => x._cid == btn.fillCids[0].cid)
        if (btn.fillType == "CREATE_REF") {
          if (!sheetDef.controls.some(x => x._cid == btn.fillCids[0].cid)) {
            this.$message.error("自定义按钮配置有误")
          }
          if (btnSheet.oneFlag && sheetData.data[btn.fillCids[0].cid]?.length == 1) {
            this.$message.error("当前已存在关联数据")
            return
          }
          this.btnSheetData = deepClone(sheetData)
          this.btnSheetId = btnSheet.refSheetId
          this.btnCcid = btnSheet._ccid
          this.btnDataId = ""
          this.$refs.btnEditDialog.open()
        } else {
          this.btnSheetId = sheetData.sheetId
          this.btnDataId = dataId
          this.$refs.fillDialog.open()
        }
      }
    }
  }
}
